module.exports = __webpack_public_path__ + "img/logo.aceca081.png";